import { render, staticRenderFns } from "./OrgPickerConfig.vue?vue&type=template&id=1f4d31a3&scoped=true"
import script from "./OrgPickerConfig.vue?vue&type=script&lang=js"
export * from "./OrgPickerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d31a3",
  null
  
)

export default component.exports